export const environment = {
  production: false,
  apiBaseUrl: 'https://api.dev.luxengine.com',
  environmentName: 'DEV',
  updateDate: '13/11/2023',
  version: '2311.1',
  firebaseConfig: {
    AdminAppConfig: {
      apiKey: "AIzaSyAafRnM_10NhpYEsnz32iUQ6_r8nRyS9b8",
      authDomain: "bwrm-dev.firebaseapp.com",
      projectId: "bwrm-dev",
      storageBucket: "bwrm-dev-member-data",
      messagingSenderId: "232649552761",
      appId: "1:232649552761:web:46d491b7df8342d6c975a8"
    },
    MemberAppConfig: {
      apiKey: "AIzaSyAafRnM_10NhpYEsnz32iUQ6_r8nRyS9b8",
      authDomain: "bwrm-dev.firebaseapp.com",
      projectId: "bwrm-dev",
      storageBucket: "bwrm-dev-member-data",
      messagingSenderId: "232649552761",
      appId: "1:232649552761:web:46d491b7df8342d6c975a8"
    }
  }
};
